import React, { useContext } from 'react';
import "../../../../ui-styles/bottomSlider/BottomDetailsSlide.css";
import { LangCtx } from "../../../../lib/context";

const DeleteConfirmModal = (props) => {
    const { l } = useContext(LangCtx);
    return (
        <div className={props.openDelete ? "btmDtlSlider visible" : "btmDtlSlider"}>
            <div className="btmDtlPaper">

                <div className="btmDtlHeader">
                    <span className="hdrTxt">{`${l.delete} ${props?.header ? props?.header : ''}`}</span>
                </div>

                <div className="btmDtlBdy">
                    {props.msg != null ?
                         <span className="summaryTxt"> {props?.msg ? props?.msg : ''}? </span> : 
                         <span className="summaryTxt">{l.conf_del}  {props?.data?.firstName ? props?.data?.firstName : ''}? </span>} 

                </div>
                <div className="hdrAction">
                    <div className="hdrActionBox">
                        <span className="hrActionTxt" onClick={props.closeDelete}>{l.cancel}</span>
                    </div>
                    {props.msg == null &&
                        <div className="hdrActionBox">
                            <span className="hrActionTxt" onClick={props.handleDelete}>{l.delete}</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}
export default DeleteConfirmModal;